import { AttributeResult, parseLensePower, parseLensesPerPack } from "@/utils/cart.utils";
import React from "react";
import RenderCurrencyInText from "../../common/RenderCurrencyInText";
interface IProps {
  title: string;
  itemInfo: Record<string, AttributeResult>;
  staticText: Record<string, string> | undefined;
  itemDetails: {
    label: string | undefined;
    value: string;
  }[];
  promotionBadgeName?: string;
}

const CartInfo = ({ title, itemInfo, itemDetails, promotionBadgeName }: IProps) => {
  return (
    <div className="pb-3">
      <p className="text-sm font-semibold">{title || ""}</p>
      {itemInfo?.variantName?.value && (
        <p className="text-sm text-tertiary-6">{itemInfo?.variantName?.value || ""}</p>
      )}

      <div className="mt-3">
        {itemDetails?.map((info, index) => {
          if (!info.label || !info.value) return;
          return (
            <p className="text-sm" key={index}>
              <span className="font-semibold">{info?.label || ""}:</span>
              <span> {info?.value || ""}</span>
            </p>
          );
        })}
        {promotionBadgeName && (
          <p className="mt-2 text-sm text-secondary-1">
          <RenderCurrencyInText text={promotionBadgeName || ""} />
          </p>
        )}
        {/* {itemInfo?.frameColor?.value && (
          <p className="mt-3 text-sm">
            <span className="font-semibold">{itemInfo?.frameColor?.translation || ""}:</span>
            <span> {itemInfo?.frameColor?.value || ""}</span>
          </p>
        )}

        {itemInfo?.frameFit?.value && (
          <p className="text-sm">
            <span className="font-semibold">{itemInfo?.frameFit?.translation || ""}:</span>
            <span> {itemInfo?.frameFit?.value || ""}</span>
          </p>
        )}

        {itemInfo?.lensColor?.value && (
          <p className="text-sm">
            <span className="font-semibold">{itemInfo?.lensColor?.translation || ""}:</span>
            <span> {itemInfo?.lensColor?.value || ""}</span>
          </p>
        )}

        {itemInfo?.gender?.value && (
          <p className="text-sm">
            <span className="font-semibold">{itemInfo?.gender?.translation || ""}:</span>
            <span> {itemInfo?.gender?.value || ""}</span>
          </p>
        )}

        {itemInfo?.model?.value && (
          <p className="text-sm">
            <span className="font-semibold">{itemInfo?.model?.translation || ""}:</span>
            <span> {itemInfo?.model?.value || ""}</span>
          </p>
        )}

        {itemInfo?.lensesPerPack?.value && (
          <p className="text-sm">
            <span className="font-semibold">{staticText?.cart_box_label || ""}:</span>
            <span>
              {" "}
              {`${parseLensesPerPack(itemInfo?.lensesPerPack?.value)} ${staticText?.common_variant_attribute_no_of_lenses_per_box_label || ""}` ||
                ""}
            </span>
          </p>
        )}

        {itemInfo?.lensesPower?.value && (
          <p className="text-sm">
            <span className="font-semibold">
              {staticText?.common_variant_attribute_power_label || ""}:
            </span>
            <span> {parseLensePower(itemInfo?.lensesPower?.value) || ""}</span>
          </p>
        )} */}
      </div>
      {/* <p className="mt-3 w-full text-xs text-secondary-1 md:text-[13px]">Buy 1 Get 1 Free</p> */}
    </div>
  );
};

export default CartInfo;
